module.exports = __webpack_public_path__ + "resources/img/img_dsm2_m_en.322cbcd6d968f6b6279b07bdd89248ef.png";